import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBfCcC9Sr6vrUzXgW-CFZBNctIbhIa77S8",
  authDomain: "arescodeworks.firebaseapp.com",
  projectId: "arescodeworks",
  storageBucket: "arescodeworks.firebasestorage.app",
  messagingSenderId: "843827251449",
  appId: "1:843827251449:web:7ebab5eeeb86955e9cba28",
  measurementId: "G-V9KV69S63M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export { app, auth, db, storage, analytics }; 